import {
    LOAD_COLLECTION_SETTINGS_SUCCESS,
    RESET_COLLECTION_SETTINGS,
    UPDATE_COLLECTION_SETTINGS_SUCCESS
} from '../../../../actions/types';

const INITIAL_STATE = []

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_COLLECTION_SETTINGS_SUCCESS:
            return action.payload;
        case UPDATE_COLLECTION_SETTINGS_SUCCESS:
            return action.payload;
        case RESET_COLLECTION_SETTINGS:
            return INITIAL_STATE;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/restaurants/settings/service/CollectionReducer.js